import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";

const api = new API();

export default class AbsenceAttendantsController
{
    async get(dateStartIntervals, dateEndsIntervals) 
    {
        const response = await api.absenceAttendants().get(dateStartIntervals, dateEndsIntervals);
        return apiCallbackTreatment(response);
    }
    
    async create(data) 
    {
        const response = await api.absenceAttendants().post(data);
        return apiCallbackTreatment(response);
    }
    
    async update(id, data) 
    {
        const response = await api.absenceAttendants().update(id, data);
        return apiCallbackTreatment(response);
    }

    async delete(id) 
    {
        const response = await api.absenceAttendants().deleteAbsence(id);
        return apiCallbackTreatment(response);
    }
    
}